<div class="multi-select-filter" #dropdownMenu>
  <!-- Dropdown Toggle -->
  <div 
    class="dropdown-toggle"
    [class.open]="isOpen"
    [class.has-selection]="selectedValues.length > 0"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="true">
    <div class="toggle-content">
      <!-- Selected Tags Inside Field -->
      <div class="selected-tags-inline" *ngIf="selectedValues.length > 0">
        <span 
          *ngFor="let value of selectedValues" 
          class="tag-inline"
          [attr.aria-label]="'Remove ' + value">
          {{ value }}
          <button 
            type="button"
            class="tag-remove"
            (click)="removeTag(value, $event)"
            [attr.aria-label]="'Remove ' + value">
            <i class="bi bi-x"></i>
          </button>
        </span>
      </div>
      <!-- Placeholder -->
      <span class="placeholder-content" *ngIf="selectedValues.length === 0">
        <i class="bi bi-funnel-fill placeholder-icon"></i>
        <span class="placeholder-text">Select values</span>
      </span>
    </div>
  </div>

  <!-- Dropdown Menu -->
  <div class="dropdown-menu" *ngIf="isOpen">
    <!-- Search Input -->
    <div class="search-container" *ngIf="searchable">
      <i class="bi bi-search search-icon"></i>
      <input 
        #searchInput
        type="text" 
        class="search-input"
        [value]="searchTerm"
        (input)="onSearchChange($any($event.target).value)"
        placeholder="Search..."
        [attr.aria-label]="'Search options'">
    </div>

    <!-- Options List -->
    <div class="options-list">
      <div 
        *ngFor="let option of filteredOptions"
        class="option-item"
        [class.selected]="isSelected(option)"
        (click)="toggleSelection(option)"
        [attr.aria-selected]="isSelected(option)"
        role="option">
        <i class="bi bi-check check-icon" *ngIf="isSelected(option)"></i>
        <span class="option-label">{{ option }}</span>
      </div>
      <div class="no-results" *ngIf="filteredOptions.length === 0">
        No results found
      </div>
    </div>
  </div>
</div>

